export default __webpack_public_path__ + "static/media/card-05.704c13df.svg";